import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
const ListingContainer = ({ title, location, business, status }) => {
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col sm={9}>
            <Card.Title>Business Title: {title}</Card.Title>
            <Card.Text>Location: {location}</Card.Text>
            <Card.Text>Status: {status}</Card.Text>
          </Col>
          <Col sm={3}>
            <div className="d-flex justify-content-end">
              <Link
                className=" nav-link text-decoration-none"
                to={`/listing-details/${business}`}
              >
                <Button className="border-0 " size="lg" variant="dark">
                  View
                </Button>
              </Link>

              <Link className="nav-link" to={`/edit-listing/${business}`}>
                <Button variant="danger" size="lg" className="addbtn">
                  Edit
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default ListingContainer;
